import React from 'react';
import LandingNavbar from './LandingNavbar';
import LandingHero from './LandingHero';
import LandingStats from './LandingStats';
import LandingFeatures from './LandingFeatures';
import LandingModules from './LandingModules';
import LandingRoles from './LandingRoles';
import LandingManagementFeatures from './LandingManagementFeatures';
import LandingScreenshots from './LandingScreenshots';
import LandingTestimonials from './LandingTestimonials';
import LandingPricing from './LandingPricing';
import LandingFAQ from './LandingFAQ';
import LandingEnquiry from './LandingEnquiry';
import LandingFooter from './LandingFooter';

export default function Landing() {
  return (
    <div className="dark min-h-screen bg-[#050816] text-white">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
        <div className="absolute -bottom-40 right-[-120px] h-[420px] w-[420px] rounded-full bg-indigo-500/10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 pb-10">
        <LandingNavbar />
        <LandingHero />
        <LandingStats />
        <LandingFeatures />
        <LandingModules />
        <LandingRoles />
        <LandingManagementFeatures />
        <LandingScreenshots />
        <LandingTestimonials />
        <LandingPricing />
        <LandingFAQ />
        <LandingEnquiry />
        <LandingFooter />
      </div>
    </div>
  );
}
